import Moment from "moment"
import { getToken, getUser } from "../../Utils/Common"
import { getAPICall, postAPICall } from "../axiosMethodCalls"

// export const getAllAttendance = async (data) => {

//     try {
//         const response = await getAPICall(
//             process.env.REACT_APP_LINK + "gate_passes/get",
//             {
//                 requester: getUser(),
//                 token: getToken(),
//                 gate_pass_id: data.id ? data.id : "",
//                 branch_id: data.branch_id ? data.branch_id : "",
//                 type: data.type ? data.type : "",
//                 transfer_no: data.transfer_no ? data.transfer_no : "",
//                 date_to: data.date_to ? Moment(data.date_to).format("YYYY-MM-DD") : "",
//                 date_from: data.date_from ? Moment(data.date_from).format("YYYY-MM-DD") : "",
//             }
//         );
//         return { data: response.data };
//     } catch (error) {
//         return { error: error.response };
//     }
// };

// export const getAttendance = async (id, transfer_id) => {
//     try {
//         const response = await getAPICall(
//             process.env.REACT_APP_LINK+"gate_passes/get",
//             {
//                 requester: getUser(),
//                 token: getToken(),
//                 gate_pass_id: id,
//                 transfer_id: transfer_id
//             }
//         )
//         return {data: response.data}
//     } catch (error) {
//         return {error: error.response}
//     }
// }

export const createAttendance = async (data) => {
  let formData = new FormData()
  formData.append("requester", getUser())
  formData.append("token", getToken())
  formData.append("branch_id", data.branch_id ? data.branch_id : "")

  data.time_sheet.map((item, index) => {
    formData.append("employee_id[]", data.employee_id ? data.employee_id : "")
    formData.append(
      "datetime[]",
      data.datetime ? data.datetime.split("T").join(" ") + ":00" : ""
    )
    formData.append("overtime[]", data.overtime ? data.overtime : "")
    formData.append(
      "overtime_remarks[]",
      data.overtime_remarks ? data.overtime_remarks : ""
    )

    // data.time_sheet.map((item) => {
    formData.append(
      `actual_timein[]`,
      data.time_sheet[index].actual_timein
        ? data.time_sheet[index].actual_timein
        : ""
    )
    formData.append(
      `actual_timeout[]`,
      data.time_sheet[index].actual_timeout
        ? data.time_sheet[index].actual_timeout
        : ""
    )
    // })
  })

  data.attachments.map((file) => {
    formData.append(`attachments[]`, file, file.name)
  })

  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "attendances/create",
      formData
    )
    return { data: response.data }
  } catch (error) {
    return { error: error }
  }
}

export const createMultipleAttendance = async (data, branch_id, file) => {
  let formData = new FormData()
  formData.append("requester", getUser())
  formData.append("token", getToken())
  formData.append("branch_id", branch_id ? branch_id : "")

  data.map((array) => {
    array?.map((details) => {
      details?.time_sheet.map((item, index) => {
        // sending the details based on the number of timeins/outs
        formData.append(
          "employee_id[]",
          details.employee_id ? details.employee_id : ""
        )
        formData.append("datetime[]", details.datetime ? details.datetime : "")

        formData.append(
          `actual_timein[]`,
          details.time_sheet[index].actual_timein
            ? details.time_sheet[index].actual_timein
            : ""
        )
        formData.append(
          `actual_timeout[]`,
          details.time_sheet[index].actual_timeout
            ? details.time_sheet[index].actual_timeout
            : ""
        )
      })
    })
  })

  file.map((file) => {
    formData.append(`attachments[]`, file, file.name)
  })

  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "attendances/create",
      formData
    )
    return { data: response.data }
  } catch (error) {
    return { error: error }
  }
}

export const updateAttendance = async (data, items) => {
  let formData = new FormData()
  formData.append("requester", getUser())
  formData.append("token", getToken())

  data.time_sheet.map((item, index) => {
    formData.append("attendance_id[]", data.id ? data.id : "")
    formData.append("branch_id[]", data.branch_id ? data.branch_id : "")
    formData.append("employee_id[]", data.employee_id ? data.employee_id : "")
    formData.append(
      "datetime[]",
      data.datetime
        ? data.datetime.split("T").length > 1
          ? data.datetime.split("T").join(" ") + ":00"
          : data.datetime
        : ""
    )
    formData.append("overtime[]", data.overtime ? data.overtime : "")
    formData.append(
      "overtime_remarks[]",
      data.overtime_remarks ? data.overtime_remarks : ""
    )

    // data.time_sheet.map((item) => {
    formData.append(
      `actual_timein[]`,
      data.time_sheet[index].actual_timein
        ? data.time_sheet[index].actual_timein
        : ""
    )
    formData.append(
      `actual_timeout[]`,
      data.time_sheet[index].actual_timeout
        ? data.time_sheet[index].actual_timeout
        : ""
    )
    // })
  })

  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "attendances/update",
      formData
    )
    return { data: response.data }
  } catch (error) {
    return { error: error }
  }
}

export const deleteAttendance = async (id) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "/gate_passes/delete",
      { requester: getUser(), token: getToken(), gate_pass_id: id }
    )
    return { data: response.data }
  } catch (error) {
    return { error: error.response }
  }
}
